var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pop-up"},[_c('button',{staticClass:"exit",on:{"click":function($event){return _vm.$emit('show',!_vm.show)}}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }